<template>
    <div class="order-products">
        <div class="flex justify-between font-bold mb-4">
            <div class="w-64 mr-8">Ruimte</div>
            <div class="flex-1 mr-8">Vierkante meter (m²)</div>
            <div class="w-24" />
        </div>
        <OrderArea
            v-for="(area, index) in combinedAreas"
            :area="area"
            :key="index"
            :index="index"
            @remove="removeArea(area)"
        />
        <button
            @click.prevent="addArea"
            class="btn-outline flex items-center"
        >
            <Icon name="plus-circle" class="mr-1" /> Ruimte toevoegen
        </button>
    </div>
</template>

<script>
    import OrderArea from './OrderArea';

    export default {
        name: 'OrderAreas',
        props: {
            areas: {
                type: Array,
                required: true,
            },
        },
        components: {
            OrderArea,
        },
        data() {
            return {
                combinedAreas: [],
            };
        },
        created() {
            this.combinedAreas = this.areas;
        },
        methods: {
            addArea() {
                this.combinedAreas.push({
                    id: null,
                    name: null,
                    square_meter: null,
                });
            },

            removeArea(area) {
                const index = this.combinedAreas.findIndex(c => c.id === area.id);
                this.combinedAreas.splice(index, 1);
            },
        },
    };
</script>
